// What the Add software blade of the policy page works out from the account's software list (cma/softwareinventory). Pure functions, no React and
// no requests. A program of the list has: key, name, versions, machines, winget {id, name, latestVersion} and, when the machines reported
// several winget ids for it, packages [{id, name, latestVersion}].

const list = (v) => (Array.isArray(v) ? v : []);

// The installed program of a device's list that is the catalog package with this id (the id the machine reported for it, or the one a policy
// rule matched it to), or undefined when the package is not installed there.
export const installedProgram = (programs, wingetId) => {
  const want = String(wingetId || '').toLowerCase();
  return want ? list(programs).find((p) => p && p.installed !== false && [p.id, p.wingetId].some((x) => String(x || '').toLowerCase() === want)) : undefined;
};

// The catalog packages of one program of the list: one for every winget id the machines reported for it (Python 3.10 and Python 3.14 are two
// packages of one program), else the single package it was matched to by name.
export const packagesOf = (program) => {
  const byId = list(program?.packages);
  if (byId.length > 0) return byId;
  return program?.winget ? [program.winget] : [];
};

// The software list's programs that are in the winget catalog, once each: the "installed in this account" choices of the Add list.
export const knownPackages = (programs) => [...new Map(list(programs).flatMap((p) => packagesOf(p).map((pkg) => [pkg.id, { id: pkg.id, name: pkg.name || p.name, latestVersion: pkg.latestVersion }]))).values()];
